import { configureCompat } from 'vue'

configureCompat({
  ATTR_FALSE_VALUE: true,
  INSTANCE_ATTRS_CLASS_STYLE: false,
  CUSTOM_DIR: false,
  TRANSITION_GROUP_ROOT: false
})
